import React, { Component } from 'react'

export default class NoMatch extends Component {
  render() {
    const { location } = this.props
    // window.location.reload()
    return (
      <div>
        <h2>
          404 - Not Found <code>{location.pathname}</code>
          <p>
            Click<a href="#/"> Here</a> to return Home page
          </p>
        </h2>
      </div>
    )
  }
}
